<template>
  <div class="fixedgoBack">
    <div class="arrow__top"  @click="gotop"><img src="../../assets/arrowUp.svg" alt=""></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      gotopflag: true
    };
  },
  methods: {
    // 判断滚动条 是否显示到达顶部
    // handleScroll(e) {
    //   if (e.target.scrollingElement) {
    //     let scrolltop = e.target.scrollingElement.scrollTop;
    //     scrolltop > 0 ? (this.gotopflag = true) : (this.gotopflag = false);
    //   }
    // },
    // 达到顶部
    gotop() {
      var timer = null;
      cancelAnimationFrame(timer);
      //获取当前毫秒数
      var startTime = +new Date();
      //获取当前页面的滚动高度
      var b = document.body.scrollTop || document.documentElement.scrollTop;
      var d = 500;
      var c = b;
      timer = requestAnimationFrame(function func() {
        var t = d - Math.max(0, startTime - +new Date() + d);
        document.documentElement.scrollTop = document.body.scrollTop =
          (t * -c) / d + b;
        timer = requestAnimationFrame(func);
        if (t == d) {
          cancelAnimationFrame(timer);
        }
      });
    }
  },
  mounted() {
    // window.addEventListener("scroll", this.handleScroll, true);
  },
  computed: {
    // 配置
    appConfig() {
      return this.$store.state.service.appConfig;
    }
  }
};
</script>

<style lang="less" scoped>
.fixedgoBack {
  position: fixed;
  bottom: 100px;
  right: 80px;
  left: auto;
  z-index: 100;

  .arrow__top {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 42px;
    height: 42px;
    background-color: #4a4a49;
    border-radius: 100%;
    cursor: pointer;

    img {
      margin: 0;
      padding: 0;
      border: 0;
      font-size: 100%;
      vertical-align: baseline;
    }
  }

}
</style>